import classNames from 'classnames';
import type { ChipSize, ChipVariant } from './Chip.types';

const baseInteractivityClassName =
  'border border-solid focus-visible:outline-none focus-visible:ring';
const baseDisabledClassName = 'border border-solid pointer-events-none';

const defaultStateClassName: { [Key in ChipVariant]: string } = {
  outline: `${baseInteractivityClassName} border-default text-default bg-default`,
  plain: `${baseInteractivityClassName} border-transparent text-default bg-shade-10`,
};

const selectedStateClassName: { [Key in ChipVariant]: string } = {
  outline: `${baseInteractivityClassName} border-status-selected text-status-selected bg-status-selected`,
  plain: `${baseInteractivityClassName} border-status-selected text-status-selected bg-shade-10`,
};

const disabledClassName: { [Key in ChipVariant]: string } = {
  outline: `${baseDisabledClassName} border-status-disabled-dark text-status-disabled-dark bg-status-disabled`,
  plain: `${baseDisabledClassName} border-transparent text-status-disabled-dark bg-status-disabled`,
};

const sizeClassName: { [Key in ChipSize]: string } = {
  small: 'text-xs rounded-sm py-4xs px-3xs gap-x-4xs',
  default: 'text-sm rounded py-4xs px-2xs gap-x-3xs',
  large: 'text-base rounded-lg py-3xs px-xs gap-x-3xs',
};

export const getChipClassNames = (
  variant: ChipVariant,
  size: ChipSize = 'default',
  selected?: boolean,
  disabled?: boolean,
  clickable?: boolean,
  className?: string,
): string =>
  classNames(
    className,
    'relative inline-flex shrink-0 items-center justify-center whitespace-nowrap',
    clickable
      ? 'cursor-pointer hover:bg-state-hover active:bg-state-press'
      : 'cursor-default',
    disabled
      ? disabledClassName[variant]
      : selected
        ? selectedStateClassName[variant]
        : defaultStateClassName[variant],
    sizeClassName[size],
  );
